import React__default from 'react';
import { ScrollIntoView, Alert } from '@grandvisionhq/common';

/** Helper component to render Alert message */ const ErrorAlert = ({ message  })=>{
    return /*#__PURE__*/ React__default.createElement(ScrollIntoView, {
        key: message
    }, /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        message: message
    }));
};

export { ErrorAlert };
//# sourceMappingURL=ErrorAlert.js.map
